import { useMutation, useQuery } from 'react-query';

import { api_v2 } from 'api/apiUtil';
import onQueryError from 'helpers/queryError';
import { queryClient } from 'queryClient';
import { successAlert } from 'utils/alert';

export const GLOBAL_SETTINGS_QUERY_KEY = 'GLOBAL_SETTINGS';

/** Tracking load-radius defaults, in miles. Seeded server-side, so never null in practice. */
export interface GlobalSettings {
  TrackingWebDefaultRadius: number | null;
  TrackingMobileDefaultRadius: number | null;
}

export interface GlobalSettingsPayload {
  TrackingWebDefaultRadius: number;
  TrackingMobileDefaultRadius: number;
}

interface UseGlobalSettingsProps {
  enabled?: boolean;
}

/** Read from the public route, so every user can have it - only Super Admin can update it. */
export const useGlobalSettings = ({ enabled = true }: UseGlobalSettingsProps = {}) =>
  useQuery({
    queryKey: [GLOBAL_SETTINGS_QUERY_KEY],
    queryFn: (): Promise<{ data: GlobalSettings }> =>
      api_v2.get('public/global_settings', {}, 'v1'),
    enabled,
    select: data => data.data,
    onError: error => onQueryError(error)
  });

export const useUpdateGlobalSettings = () =>
  useMutation({
    mutationFn: (payload: GlobalSettingsPayload) =>
      api_v2.put('admin/global_settings', payload, {}, 'v4'),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GLOBAL_SETTINGS_QUERY_KEY] });
      successAlert('Global Settings Updated');
    },
    onError: error => onQueryError(error)
  });
